import { useState } from 'react';
import companyLogo from "../assets/2.png";

const LoginForm = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);

  const handleLogin = () => {
    if (loading) return;
    setLoading(true);
    try {
      onLogin();
    } catch (err) {
      console.error("Login failed:", err);
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="welcome-message" style={{
        textAlign: 'center',
        padding: '1rem',
        position: 'relative'
      }}
      >        <img
          src={companyLogo}
          alt="Company Logo"
          style={{ width: '200px', height: 'auto' }}
        />      <h2 style={{ color: '#000000'}}>Welcome to Secure Forms</h2>
      <p style={{ color: '#000000', fontWeight: 'bold', fontSize: '1.2rem' }}>Please log in using your Microsoft account</p>
      <button onClick={handleLogin} disabled={loading} style={{ padding: '1rem 4rem', fontSize: '1.2rem', backgroundColor: '#2A3990', color: 'white', border: 'none', borderRadius: '4px' }} onMouseEnter={(e) => (e.target.style.backgroundColor = '#83bfffff', e.target.style.color = '#000000ff')} onMouseLeave={(e) => (e.target.style.backgroundColor = '#2A3990', e.target.style.color = 'white')}>
        {loading ? 'Redirecting…' : 'Login'}
      </button>
    </div>
  </div>
  );
};

export default LoginForm;
